module.exports = __webpack_public_path__ + "img/12.7ca2bf73.png";